import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import LoginView from '@/views/login/LoginView.vue'
import HomeView from '@/views/home/HomeView.vue'
import { loadSession } from '@/core/storage/session'
import { useRouteStore } from '@/stores/route'
import { collectMenuPaths } from '@/router/catalog'

const IvusCompressionRecordView = () => import('@/views/ivus/IvusCompressionRecordView.vue')

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: () => useRouteStore().firstPath || '/login' },
  { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
  {
    path: '/',
    name: 'app',
    component: AppLayout,
    children: [
      { path: 'index', name: 'home', component: HomeView, meta: { title: '系统首页' } },
      {
        path: 'ivusmanage/compression-records',
        name: 'ivus-compression-records',
        component: IvusCompressionRecordView,
        meta: { title: '压缩记录' }
      }
    ]
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', redirect: () => useRouteStore().firstPath || '/login' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

router.beforeEach((to) => {
  const session = loadSession()
  const routeStore = useRouteStore()
  if (to.meta.public) {
    if (session?.tokenValue && to.name === 'login' && routeStore.firstPath) return routeStore.firstPath
    return true
  }
  if (!session?.tokenValue) return '/login'
  if (to.path === '/index' && !collectMenuPaths(routeStore.menus).has('/index')) {
    return routeStore.firstPath || '/login'
  }
  return true
})

router.onError((error) => {
  if (/Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i.test(error.message)) {
    window.location.reload()
  }
})

export default router
